<template>
    <div id="Header">
      <div class="header_content content_1040">
        <div class="left">
          <router-link class="logo"  :to="{ path : '/' }" tag="div">
            <img src="@/assets/logo/header_logo.png" alt="">
          </router-link>
          <div class="list_link">
           <nav>
              <router-link class="link_item" tag="a" :to="{ path: '/'}" active-class="active" exact>首页</router-link>
<!--              <router-link class="link_item" tag="a" :to="{ path: '/login'}" active-class="active">专家</router-link>-->
<!--              <router-link class="link_item" tag="a" :to="{ path: '/Register'}" active-class="active">课程</router-link>-->
<!--              <router-link class="link_item" tag="a" :to="{ path: '/Forget'}" active-class="active">文档</router-link>-->
            </nav>
          </div>
        </div>
        <div class="right">
          <!--未登录-->
          <div class="login_entrance" v-if="!isLogin">
            <router-link :to="{ path: 'Login'}" tag="span">登录</router-link>
            <b>|</b>
            <router-link :to="{ path: 'Register'}" tag="span">注册</router-link>
          </div>
          <!--已登录-->
          <div class="user_info" v-else=""
               @mouseover="mouseOver('user')"
               @mouseleave="mouseLeave('user')">
            <img :src="JSON.stringify(UserPhoto) == '{}' ? default_avater : UserPhoto.original[0].url" alt="" class="photo">
            <div class="user_operation_list" v-show="HoverUser">
              <ul>
                <!-- <router-link :to="{ name: 'Outline_list'}" v-if="isExport" tag="li" class="wd">文档管理</router-link> -->
                <li class="tc" @click="SignOut()">退出</li>
              </ul>
            </div>
          </div>

          <!--<div class="bg_blue upload">上传文档</div>-->
          <router-link class="bg_blue upload" v-if="isExport && isLogin" tag="div" :to="{ name : 'Edit_document'}">上传文档</router-link>
          <div class="bg_blue app_download"
               @mouseover="mouseOver('APP')"
               @mouseleave="mouseLeave('APP')">
            <div class="text">
              <span>APP下载</span>
              <i :class="[HoverAPP ? 'on' : '','icon_arrow']"></i>
            </div>
            <transition name="el-fade-in-linear">
              <div class="QR-Code_part" v-show="HoverAPP">
                <!--客户端下载-->
                <div class="item app">
                  <img src="~@/assets/logo/app.jpg" alt="">
                  <p class="title">全球专家1对1<br>扫码获取服务</p>
                </div>
                <!--小程序-->
                <!--<div class="item wx">-->
                  <!--<img src="https://www.tmtpost.com/public/css/img/app_qrcode.png" alt="">-->
                  <!--<p class="title">小程序</p>-->
                <!--</div>-->
              </div>
            </transition>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
    let _self;
    export default {
        name: "Header",
      data(){
          return{
            isLogin : false,//是否登录
            HoverAPP : false,//是否显示APP下载
            HoverUser : false,//是否显示用户功能列表
            UserPhoto : '',//用户头像
            default_avater: 'https://www.tmtpost.com/public/css/img/avatar/avatar_2.png',//默认头像
            // default_avater: require('@/assets/ceshi/ceshi1.jpg'),//默认头像
            isExport: false,//是否是专家
          }
      },
      created(){
        _self = this;
        _self.getUser_info();//获取用户信息
      },
      methods : {
          /**
           *  获取用户信息
           */
          getUser_info:()=>{
            let user_info = JSON.parse(localStorage.getItem('user_info'));
            if(!user_info)return;
            _self.isLogin = user_info.isLogin;//是否登录
            _self.UserPhoto = user_info.avatar;//用户头像
            _self.isExport = user_info.expert_status.isExpert;//是否是专家
          },
        /**
         * APP下载鼠标移入
         * @param res
         */
        mouseOver : (type) => {
          if(type === 'APP'){
            _self.HoverAPP = true;
          }else if(type === 'user'){
            _self.HoverUser = true;
          }
        },
        /**
         * APP下载鼠标移出
         * @param res
         */
        mouseLeave : (type) => {
          if(type === 'APP') {
            _self.HoverAPP = false;
          }else if(type === 'user'){
            _self.HoverUser = false;
          }
        },
        /**
         * 退出登录
         */
        SignOut : ()=> {
          _self.$tkApi.delete('/account/logout')
            .then(res => {
              _self.$log(res);
              let resData = res.data;
              if(resData.result === 'ok'){
                localStorage.removeItem('user_info');//清空本地储存的用户信息
                _self.$VueX.state.state.access_token = ''; //访问令牌
                _self.$VueX.state.state.user_unique_key = ''; //访问令牌
                _self.$VueX.state.state.expiration = ''; //到期时间
                _self.$VueX.state.state.isLogin = false; //登录状态
                _self.$message({
                  message: '成功退出登录',
                  type: 'success'
                });
                setTimeout(()=>{
                  _self.$route.path === '/' ? _self.$router.go() : _self.$router.push('/');
                },2000);
              }
            })
            .catch(err => {
              console.log(err);
              let errData = err.data;
              if(errData.result === "no_ok"){
                _self.$message({
                  message: errData.errors[0].message,
                  type: 'error'
                })
              }
            })
        }
      }
    }
</script>

<style scoped lang="scss">
  #Header{
    /*position: fixed;*/
    /*top: 0;left: 0;right:0;*/
    z-index: 999;
    height:60px;
    background:#FFF;
    border-bottom: 1px solid #E5E8F0;
    .header_content{
      height: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      /*左侧*/
      .left{
        display: flex;
        /*logo*/
        .logo{
          width:92px;
          height:34px;
          margin-right:80px;
          cursor: pointer;
        }
        /*导航部分*/
        .list_link{
          nav{
            height:100%;
            display: flex;
            align-items: center;
          }
          .link_item{
            font-size:14px;
            color:rgb(98,105,123);
            line-height:20px;
            margin-right:60px;
            text-decoration: none;
            &:last-child{
              margin-right:0;
            }
            &.active{
              color: #3A68F9;
              font-weight: bold;
            }
          }
        }
      }
      /*右侧*/
      .right{
        display: flex;
        align-items: center;
        height:100%;
        /*登录注册入口*/
        .login_entrance{
          font-size:14px;
          color:rgb(98,105,123);
          line-height:20px;
          span{
            cursor: pointer;
            &:hover{
              color: #3A68F9;
            }
          }
          b{
            margin:0 15px;
          }
        }
        /*用户已登录部分*/
        .user_info{
          height: 100%;
          width: 50px;
          cursor: pointer;
          position: relative;
          display: flex;
          align-items: center;
          justify-content: flex-end;
          margin-right:20px;
          /*头像*/
          .photo{
            width: 36px;
            height:36px;
            border-radius: 100%;
          }
          /*用户操作列表*/
          .user_operation_list{
            position: absolute;
            right: 0;
            top: 55px;
            width:180px;
            background:rgba(255,255,255,1);
            box-shadow:0px 1px 4px 0px rgba(110,128,174,.3);
            border:1px solid rgb(222,228,235);
            z-index: 999;
            &:before{
              position: absolute;
              top: -7px;
              right:10px;
              content: '';
              width: 20px;
              height: 12px;
              background: url("~@/assets/icon/icon_header-arow.png") no-repeat;
              background-size: contain;
            }
            li{
              height:48px;
              line-height: 48px;
              padding:0 14px;
              font-size:13px;
              color:rgb(108,118,149);
              background-repeat: no-repeat;
              background-size: 14px 14px;
              background-position: 150px center;
              &:hover{
                background-color: #6E80AE;
                color: #fff;
              }
              &.wd{
                background-image: url('~@/assets/icon/icon_header-wd.png');
                &:hover{
                  background-image: url('~@/assets/icon/icon_header-wd-hover.png');
                }
              }
              &.tc{
                background-image: url('~@/assets/icon/icon_header-tc.png');
                &:hover{
                  background-image: url('~@/assets/icon/icon_header-tc-hover.png');
                }
              }
            }
          }
        }
        //右侧功能按钮部分
        .bg_blue{
          background:rgba(58,104,249,.1);
          border-radius:2px;
          padding:10px 20px;
          font-size:12px;
          color:rgb(58,104,249);
          line-height:17px;
          cursor: pointer;
          /*上传文档*/
          &.upload{
            margin-left: 20px;
          }
          /*下载APP*/
          &.app_download{
            margin-left:20px;
            position: relative;
            margin-left: 20px;
            /*文字部分*/
            .text{
              display: flex;
              align-items: center;
              .icon_arrow{
                display: block;
                width: 8px;
                height:4px;
                background: url("~@/assets/icon/icon_arrow-blue.png");
                background-size: 8px 4px;
                margin-left:10px;
                transition: all .3s linear;
                transform:rotate(0deg);
                -ms-transform:rotate(0deg); /* IE 9 */
                -webkit-transform:rotate(0deg); /* Safari and Chrome */
                &.on{
                  transform:rotate(180deg);
                  -ms-transform:rotate(180deg); /* IE 9 */
                  -webkit-transform:rotate(180deg); /* Safari and Chrome */
                }
              }
            }
            /*二维码部分*/
            .QR-Code_part{
              z-index: 999;
              position: absolute;
              top: 40px;left: 0;
              padding:12px 20px;
              /*width:220px;*/
              height:148px;
              background:rgb(237,241,255);
              border-radius:2px;
              display: flex;
              .item{
                width: 80px;
                height:80px;
                img{
                  border: 1px solid rgba(58,104,249,.2);
                }
                .title{
                  text-align: center;
                  margin-top: 10px;
                  font-size:12px;
                  color:rgb(51,51,51);
                  line-height:18px;
                }
              }
              /*客户端下载*/
              .app{
                /*margin-right: 20px;*/
              }
              /*小程序*/
              .wx{}
            }
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Header.vue